import React from "react";
import {LoadMenuGroupDetailsEpic} from '../../actions/website.actions';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux'
import { withRouter, Switch, Route } from 'react-router-dom'
import {push} from 'react-router-redux';

import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import ErrorBlock from '../../components/ErrorBlock';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import ResourceList from '../../components/ResourceList';

export class GroupDetails extends React.Component {
  constructor(props){
    super(props);
    this.state = { menu_group: {}};
  }
  componentDidMount() {
    this.props.loadMenuGroupDetails(this.props.websiteId, this.props.menuId, this.props.groupId);
  }

  componentWillReceiveProps(newProps){
    this.setState(newProps);
  }

  viewGroup = (rowData) => {
    this.props.navigateToGroupMenuItem(this.props.match.params.websiteId, this.props.match.params.menuId, this.props.match.params.groupId, rowData.id);
  }

  getColumns = () => {
    return [
      {name: 'menu_item_name', label: 'Item Name', render: (rowData) => <span>{ rowData.menu_item_name ? rowData.menu_item_name : '<no name>' }</span>},
      {name: 'details', width: 68, label: 'Action', render: (rowData) => <span><FlatButton onClick={this.viewGroup.bind(this,rowData)} label='View' primary={true}/></span>}
    ]
  }

  Field = ({propName, label, ...props}) => {
    return (
      <TextField {...props}
        floatingLabelText={label} 
        value={this.state.menu_group[propName]} 
        onChange={(e)=> this.setState({
          menu_group: { ...this.props.menu_group, [propName]: e.target.value}
        })}
        errorText={this.state[`${propName}ValidationError`]}
      />
    );
  }

  onSave() {

  }

  groupDetails() {
    return (
      <div>
        <h1>Menu Group Details</h1>
            <this.Field propName="group_name" label="Group Name*" fullWidth={true}/><br/>
            <this.Field propName="group_note" label="Note" fullWidth={true}/><br/>
            <this.Field propName="group_description" label="Description" fullWidth={true}/><br/>
            <this.Field propName="disabled" label="Disabled" fullWidth={true}/><br/>
            <RaisedButton onClick={this.onSave} label="Save" primary={true}/>
            <RaisedButton onClick={this.onDelete} label="Delete" primary={false}/>
        <br/>
        <br/>
        <h1>Menu Items</h1>
        <FlatButton label="+ Add Item" primary={true} onClick={()=>this.setState({redirectToAdd: true})}/>
                {this.state.redirectToAdd? <Redirect to="/menus/add"/> : null }
        <ResourceList showHeader={false} columns={this.getColumns()} data={this.props.menu_group.menu_items} showCheckboxes={false}/>
      </div>
      );
  }

  render() {
    if (this.props.loading) {
      return  <div style={{textAlign: 'center'}}><CircularProgress/></div>;
    }

    if (this.props.error) {
      return <ErrorBlock errorText="Unable to retrieve menu details at this time."/>
    }

    if (!this.props.menu_group){
      return <span></span>;
    }

    return (
     <div>
       <div>
         <div>
            <Switch> 
              <Route path='/websites/:websiteId/menu/:menuId/group/:groupId/details' render={() => this.groupDetails()}/>
              <Route path='/websites/:websiteId/menu/:menuId/group/:groupId' exact={true} render={() => this.groupDetails()}/>
            </Switch>
          </div>
         </div>
      </div>);
  }
}

let mapStateToProps = ({websiteEndpoint, referenceData},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError,
  menuId: match.params.menuId,
  websiteId: match.params.websiteId,
  groupId: match.params.groupId,
  menu_group: websiteEndpoint.menu_group
})

let mapDispatchToProps = (dispatch) => ({
  loadMenuGroupDetails : (websiteId, menuId, groupId) => dispatch(LoadMenuGroupDetailsEpic(websiteId, menuId, groupId)),
  navigateToGroupMenuItem: (websiteId, menuId, groupId, menuItemId) => dispatch(push(`/websites/${websiteId}/menu/${menuId}/group/${groupId}/item/${menuItemId}`))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(GroupDetails));



// WEBPACK FOOTER //
// ./src/containers/Menu/GroupDetails.js